<div class="row row-header mb-3">
	<div class="col-3 d-block">

		<div class="breadcrumbs">
			<button data-testid="SUBSYS2_PLANFORM_BACK_BTN" type="button"
				class="btn btn-secondary-outline d-flex align-items-center px-3 py-2"
				(click)="back()">
				<i class="material-icons">arrow_back</i>
				{{ labels().PLAN_CREATION_COMPONENT_PREVIOUS_PAGE }}
			</button>
		</div>

		<h1 data-testid="SUBSYS2_PLANFORM_TITLE_TXT">
			{{ planFormSrv.isEdit ? labels().PLAN_CREATION_COMPONENT_TITLE_EDIT :
			labels().PLAN_CREATION_COMPONENT_TITLE_CREATE }}
		</h1>

	</div>

	<div class="col-9">
		<div class="panel mb-0 p-0 bg-transparent">
			<div class="panel alert flex-grow-0 mb-0 py-3">
				<div class="state-icon"><i class="material-icons md-18">report_problem</i></div>
				<p data-testid="SUBSYS2_PLANFORM_LIABILITY_TXT" [innerHTML]="labels().PLAN_FORM_COMPONENT_LIABILITY_MESSAGE">
				</p>
			</div>
		</div>
	</div>
</div>

<div class="row row-contents justify-content-center">

	<ul ngbNav #nav="ngbNav" [(activeId)]="planFormSrv.activeTab" class="nav-tab stepper-wrapper" [destroyOnHide]="true"
		(navChange)="planFormSrv.nextTab($event)">
		<li data-testid="SUBSYS2_PLANFORM_DATA_TAB" class="stepper" [ngbNavItem]="1">
			<a data-testid="SUBSYS2_PLANFORM_DATA_TAB_BTN" ngbNavLink>
				<div class="stepper-icon" [class.success]="planFormSrv.isDataTabSuccess">
					1<i class="material-icons">done</i>
				</div>
				<div class="stepper-label">{{ labels().PLAN_CREATION_COMPONENT_DATA_TAB }}</div>
			</a>
			<ng-template ngbNavContent>
				@if (isWarningVisible) { <ng-container *ngTemplateOutlet="planResetWarning"></ng-container> }
				<div class="row row-gap-4">
					<div class="col-xl-10">
						<plan-data />
					</div>
					<div class="col-xl-2">
						<plan-overview />
					</div>
				</div>
			</ng-template>
		</li>
		<li data-testid="SUBSYS2_PLANFORM_SETUP_TAB" class="stepper" [ngbNavItem]="2">
			<a data-testid="SUBSYS2_PLANFORM_SETUP_TAB_BTN" ngbNavLink>
				<div class="stepper-icon" [class.success]="planFormSrv.isSetupTabSuccess">
					2<i class="material-icons">done</i>
				</div>
				<div class="stepper-label">{{ labels().PLAN_CREATION_COMPONENT_SETUP_TAB }}</div>
			</a>
			<ng-template ngbNavContent>
				@if (isWarningVisible) { <ng-container *ngTemplateOutlet="planResetWarning"></ng-container> }
				<div class="row row-gap-4">
					<div class="col-xl-10">
						<plan-setup />
					</div>
					<div class="col-xl-2">
						<plan-overview />
					</div>
				</div>
			</ng-template>
		</li>
		<li data-testid="SUBSYS2_PLANFORM_ANALYSIS_TAB" class="stepper" [ngbNavItem]="3"
			[disabled]="!planFormSrv.isAnalysisTabEnabled">
			<a data-testid="SUBSYS2_PLANFORM_ANALYSIS_TAB_BTN" ngbNavLink>
				<div class="stepper-icon">3</div>
				<div class="stepper-label">{{ labels().PLAN_CREATION_COMPONENT_ANALYSIS_TAB }}</div>
			</a>
		</li>
	</ul>

	<div class="position-relative">
		<div [ngbNavOutlet]="nav" class="mt-2"></div>
		@if (isArrowsVisible) {
		@if (planFormSrv.activeTab == 2) {
		<button data-testid="SUBSYS2_PLANFORM_ARROW_PREV_BTN" class="stepper-arrow" (click)="prev()">
			<i class="material-icons">arrow_left</i>
		</button>
		}
		<button data-testid="SUBSYS2_PLANFORM_ARROW_NEXT_BTN" class="stepper-arrow right"
			[class.animated]="planFormSrv.isTabNextEnabled" (click)="next()">
			<i class="material-icons">arrow_right</i>
		</button>
		}
	</div>

</div>


<ng-template #planResetWarning>
	<div class="alert alert-warning d-flex align-items-center py-3 rounded-3" role="alert">
		<i class="material-icons md-18 me-3">report_problem</i>
		@if (isResetImagesWngVisible) { {{ labels().PLAN_FORM_COMPONENT_RESET_IMAGES_WARNING }} <br> }
		@else if (isResetAnalysisWngVisible) { {{ labels().PLAN_FORM_COMPONENT_RESET_ANALYSIS_WARNING }} <br> }
	</div>
</ng-template>